import { InitiativeStatusReference } from '@types';

import { CollectionResponse, createGetEndpoint } from '@sonar-software/sonar-http';

export type GetInitiativeStatusesResponse = CollectionResponse<InitiativeStatusReference>;

export const getInitiativeStatuses = createGetEndpoint<void, GetInitiativeStatusesResponse>(
	'/api/v3/initiatives/statuses'
);
